module.exports = __webpack_public_path__ + "static/img/RAKU2_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAKU2_1.png
// module id = p/Mn
// module chunks = 0